import SecureLS from 'secure-ls';
import { APP_SLS_KEY } from '~/config';

const vault = new SecureLS({
    encodingType: 'aes',
    encryptionSecret: APP_SLS_KEY,
});

export { vault };
